import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { AdvantagesList as Desk } from './desk'
import { AdvantagesList as Mob } from './mob'

type Props = {
  images: TImages
}
export const AdvantagesList: React.FC<Props> = ({ images }) => {
  const { isMobile } = useDimensions()
  const Component = isMobile ? Mob : Desk

  return <Component images={images} />
}
